module.exports = __webpack_public_path__ + "static/img/03_positive.8a5768a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/03_positive.png
// module id = iL6e
// module chunks = 176